import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { Link, useLocation } from "react-router-dom";

export const Navigation = () => {
  const { user } = useAuth();
  const location = useLocation();

  const handleLogout = async () => {
    await supabase.auth.signOut();
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="/lovable-uploads/99a2a5d5-d865-4524-8714-25f9f98348d2.png" 
              alt="Heaven Bound Christian Family Ministries Logo" 
              className="w-12 h-12"
            />
            <span className="text-2xl font-serif font-bold text-sage-800">
              Husband & Wife Devotional
            </span>
          </Link>
          
          <nav className="flex items-center space-x-6">
            <Link
              to="/"
              className={`text-lg ${
                location.pathname === "/" ? "text-sage-800 font-medium" : "text-sage-600 hover:text-sage-800"
              }`}
            >
              Today
            </Link>
            <Link
              to="/archive"
              className={`text-lg ${
                location.pathname === "/archive" ? "text-sage-800 font-medium" : "text-sage-600 hover:text-sage-800"
              }`}
            >
              Archive
            </Link>
            <Link
              to="/about"
              className={`text-lg ${
                location.pathname === "/about" ? "text-sage-800 font-medium" : "text-sage-600 hover:text-sage-800"
              }`}
            >
              About
            </Link>
            <Link
              to="/contact"
              className={`text-lg ${
                location.pathname === "/contact" ? "text-sage-800 font-medium" : "text-sage-600 hover:text-sage-800"
              }`}
            >
              Contact
            </Link>
            <Link
              to="/donate"
              className={`text-lg ${
                location.pathname === "/donate" ? "text-sage-800 font-medium" : "text-sage-600 hover:text-sage-800"
              }`}
            >
              Donate
            </Link>
            {user ? (
              <Button variant="outline" onClick={handleLogout}>
                Sign Out
              </Button>
            ) : (
              <Link to="/login">
                <Button variant="default">Sign In</Button>
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};